/** Loops / profile attribution for the Join (Aaron) funnel deploy. */
export const FUNNEL_SOURCE_EN = 'Join-funnel';
export const FUNNEL_SOURCE_ES = 'Join-funnel-es';

/** Canonical Stripe analytics funnel id for Join checkout metadata. */
export const STRIPE_FUNNEL_SOURCE = 'join';

export function getJoinFunnelSource(isEs: boolean): string {
    return isEs ? FUNNEL_SOURCE_ES : FUNNEL_SOURCE_EN;
}

export function getStripeFunnelSource(): string {
    return STRIPE_FUNNEL_SOURCE;
}
